import { Box, Typography } from '@mui/material';

const OnboardingHeader = ({
  title,
  subTitle,
}: {
  title?: string | null | JSX.Element;
  subTitle?: string | null | JSX.Element;
}) => {
  return (
    <Box>
      {!!title && (
        <Typography
          gutterBottom
          variant="h3"
          fontWeight={400}
          color="primary"
          mb={subTitle ? '0.5rem' : '2rem'}
        >
          {title}
        </Typography>
      )}

      {!!subTitle && (
        <Typography
          variant="body1"
          fontWeight={500}
          marginTop={'1rem'}
          marginBottom={'2rem'}
        >
          {subTitle}
        </Typography>
      )}
    </Box>
  );
};

export default OnboardingHeader;
